import React from "react";
import "../styles/StatCardTwo.css";

const StatCardTwo = () => {
    return (
        <div className="stat-card-two">
            <h2>100+</h2>
            <p className="stat-description">
                Our Esteemed <br />
                Clients and <br />
                Partners
            </p>
        </div>
    );
};

export default StatCardTwo;
